module.exports = __webpack_public_path__ + "front/img/b37.32a1c397.png";